var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-list',{attrs:{"show-tag-filter":"","show-tag-columns":"","show-tag-columns2":"","show-tag-config":"","list":_vm.list,"columns":_vm.columns,"group-actions":_vm.groupActions,"single-actions":_vm.singleActions,"tag-config-params":_vm.tagConfigParams,"tag-filter-resource":"credentials"}})
}
var staticRenderFns = []

export { render, staticRenderFns }